enum AuthenticationModeEnum {
    LocalOnly = "LocalOnly",
    ExternalOnly = "ExternalOnly",
    Mixed = "Mixed"
};

export default AuthenticationModeEnum;